// ---------------------------------------------------------------------------
// Page level SEO copy (title / description / canonical) for the B2B site.
//
// Source: "Need to Update Meta Tags and Canonical Tags for B2C and B2B
// Websites" sheet. Only the pages listed here get their own copy; every
// other route keeps the site default (see `getDefaultSeo`).
// ---------------------------------------------------------------------------

export const SEO_CONTENT = {
  '/login': {
    title: 'B2B Travel Booking Portal for Agents & Partners | Fastays',
    description:
      'Fastays offers a B2B travel booking platform for agents and partners to book flights, hotels, and holiday packages with competitive rates and seamless management tools.',
  },
  '/privacy-policy': {
    title: 'B2B Privacy Policy for Travel Agents & Partners | Fastays',
    description:
      'Fastays is committed to protecting the privacy of travel agents and partners. Learn how we collect, use, store, and safeguard your information.',
  },
  '/terms-conditions': {
    title: 'B2B Terms & Conditions for Travel Agents | Fastays',
    description:
      'Review the terms and conditions governing the use of the Fastays B2B travel portal, including bookings, payments, cancellations, and agent responsibilities.',
  },
  '/about-us': {
    title: 'About Us & Company Profile for Travel Agents | Fastays',
    description:
      'Fastays is a growing B2B travel platform helping agents book flights, hotels, and holiday packages with competitive pricing and reliable support',
  },
  '/contact-us': {
    title: 'Contact Us for B2B Travel Support & Assistance | Fastays',
    description:
      'Contact Fastays for assistance with B2B travel bookings, agent accounts, payments, cancellations, partnerships, and other travel-related queries.',
  },
};

/** Site wide fallback used for routes without their own SEO copy. */
export const getDefaultSeo = (projectName = 'B2B Site') => ({
  title: projectName,
  description: `${projectName}, best b2b travel portal`,
});

/** "/About-Us/" -> "/about-us" so trailing slashes / case still match. */
export const normalizePath = (pathname) => {
  const path = String(pathname || '/').toLowerCase();
  return path.length > 1 ? path.replace(/\/+$/, '') : path;
};

/**
 * SEO record for a pathname. `canonical` is only set for pages that have
 * their own copy - it is built from the current origin, so it resolves to
 * https://agents.fastays.com/<page> in production.
 */
export const getSeoForPath = (pathname, projectName) => {
  const path = normalizePath(pathname);
  const pageSeo = SEO_CONTENT[path];
  if (!pageSeo) {
    return { ...getDefaultSeo(projectName), canonical: '' };
  }
  return { ...pageSeo, canonical: `${window.location.origin}${path}` };
};
